import Axios from 'axios';

const RESOURCE_NAME_UPLOADFILE = '/Leads/CargarExcel';

const oldAPI = process.env.VUE_APP_WS_ENDPOINT;

export default {
    upload: {
        file(data) {
            var formData = new FormData();
            formData.append('file', data.file);
            return Axios.post(`${RESOURCE_NAME_UPLOADFILE}?tipoLead=${data.tipoLead}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }
    }
};